import React from 'react';
import { UserContext } from '../../../Application';
import { hasPermissions, hasViewAllPermission, PERMISSIONS } from '../../../constants/authentication/permissions';
import { Redirect } from 'react-router';
import { ALL_ORGS_CONTEXT } from '../../../constants/admin/settings';
import { addContextToRoute } from '../../../lib/route.utils';
import { maxBy } from 'lodash';
export function AdminWrapper(AdminComponent, contextSetter, permission = PERMISSIONS.ACCESS_ADMIN) {
    return class extends React.Component {
        constructor(props) {
            super(props);
            contextSetter(this.props.match.params.context || ALL_ORGS_CONTEXT.id);
        }
        render() {
            return (
                <UserContext.Consumer>
                    {(user) => {
                        if (hasPermissions(user, PERMISSIONS.GOD) || hasViewAllPermission(user)) {
                            return <AdminComponent contextId={this.props.match.params.context} {...this.props} />;
                        } else if (hasPermissions(user, PERMISSIONS.ACCESS_ADMIN, permission)) {
                            const highestRole = maxBy(user.roles, 'level');
                            return this.props.match.params.context ? (
                                <AdminComponent contextId={this.props.match.params.context} {...this.props} />
                            ) : (
                                <Redirect
                                    to={{
                                        pathname: addContextToRoute(this.props.location.pathname, highestRole.orgId),
                                    }}
                                />
                            );
                        } else if (user.fetched) {
                            return (
                                <Redirect
                                    to={{
                                        pathname: hasPermissions(user, PERMISSIONS.ACCESS_ADMIN) ? '/admin' : '/',
                                    }}
                                />
                            );
                        } else {
                            return null;
                        }
                    }}
                </UserContext.Consumer>
            );
        }
    };
}



// WEBPACK FOOTER //
// ./src/components/admin/hocs/AdminWrapper.js